module.exports = __webpack_public_path__ + "static/media/drl1.png.07e37777.jpg";